import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components/macro';

import { ThemeModeE, useThemeMode } from 'contexts/MaterialProvider';
import { mainThemeDark, mainThemeLight } from 'theme/mainTheme';

interface StyledThemeProviderProps {
  children: ReactNode;
}

/**
 * Provides styled-components theme based on current light/dark mode.
 * Must be used inside MaterialProvider.
 */
export const StyledThemeProvider = ({ children }: StyledThemeProviderProps): JSX.Element => {
  const { mode } = useThemeMode();
  const theme = mode === ThemeModeE.Dark ? mainThemeDark : mainThemeLight;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
